import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
} from '../core/ReactiveState.mjs';
import { await1uwe8zvsjq69o as await_0 } from './DependencyChangeListener.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  onRemove3k528udkni1ni as onRemove,
  Key_instancedbf5f19vpr99 as Key_instance,
} from './CalculationContext.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ReactiveLoadings35224pps2d9 as ReactiveLoading,
  reactive2xic0rufq5s8n as reactive,
} from './ReactiveContext.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../core/signals.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { DebounceReactive1svue0nfgksym as DebounceReactive } from '../extensions/debounce.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Key_getInstance20c05dl0yuxib as Key_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import {
  CoroutineStart_DEFAULT_getInstance3qi77grrvmsn3 as CoroutineStart_DEFAULT_getInstance,
  CoroutineStart_UNDISPATCHED_getInstance36t7e2kqqnuqp as CoroutineStart_UNDISPATCHED_getInstance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CoroutineScopeHelpers$bind$slambda$slambda($this_bind) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    yield* $this_bind.set_revjhg_k$(value, $completion);
    return Unit_instance;
  }), 1);
}
function CoroutineScopeHelpers$bind$slambda$slambda_0($master) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    yield* $master.set_revjhg_k$(value, $completion);
    return Unit_instance;
  }), 1);
}
function CoroutineScopeHelpers$bind$slambda($reportTo, $master, $this_bind, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    $reportTo.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
    // Inline function 'com.lightningkite.reactive.core.reactiveState' call
    var tmp;
    try {
      var intendedValue = {_v: yield* await_0($master, $completion)};
      yield* $this_bind.set_revjhg_k$(intendedValue._v, $completion);
      var setReplica = oneAtATime(this$0, false, CoroutineScopeHelpers$bind$slambda$slambda($this_bind));
      var setMaster = oneAtATime(this$0, true, CoroutineScopeHelpers$bind$slambda$slambda_0($master));
      // Inline function 'kotlin.also' call
      var this_0 = $master.addListener_6y9mct_k$(() => {
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        var this_0 = $master.get_state_wc71uu_k$();
        var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp;
        if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
          tmp = null;
        } else {
          if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
            tmp = null;
          } else {
            if (tmp0_subject instanceof InternalReactiveThrownException()) {
              _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
              tmp = null;
            } else {
              if (tmp0_subject instanceof InternalReactiveWrapper()) {
                var it = _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
                if (!equals(intendedValue._v, it)) {
                  intendedValue._v = it;
                  setReplica(it);
                }
                tmp = Unit_instance;
              } else {
                var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
                if (!equals(intendedValue._v, it_0)) {
                  intendedValue._v = it_0;
                  setReplica(it_0);
                }
                tmp = Unit_instance;
              }
            }
          }
        }
        return Unit_instance;
      });
      onRemove(this$0, this_0);
      // Inline function 'kotlin.also' call
      var this_1 = $this_bind.addListener_6y9mct_k$(() => {
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        var this_0 = $this_bind.get_state_wc71uu_k$();
        var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp;
        if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
          tmp = null;
        } else {
          if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
            tmp = null;
          } else {
            if (tmp0_subject instanceof InternalReactiveThrownException()) {
              _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
              tmp = null;
            } else {
              if (tmp0_subject instanceof InternalReactiveWrapper()) {
                var it = _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
                if (!equals(intendedValue._v, it)) {
                  intendedValue._v = it;
                  setMaster(it);
                }
                tmp = Unit_instance;
              } else {
                var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
                if (!equals(intendedValue._v, it_0)) {
                  intendedValue._v = it_0;
                  setMaster(it_0);
                }
                tmp = Unit_instance;
              }
            }
          }
        }
        return Unit_instance;
      });
      onRemove(this$0, this_1);
      tmp = _ReactiveState___init__impl__fvdp9b(Unit_instance);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException()) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof ReactiveLoading()) {
          var _unused_var__etf5q3 = $p;
          tmp_0 = Companion_getInstance().notReady_1;
        } else {
          if ($p instanceof Exception()) {
            var e_0 = $p;
            tmp_0 = Companion_getInstance().exception_iibuh2_k$(e_0);
          } else {
            throw $p;
          }
        }
      }
      tmp = tmp_0;
    }
    var tmp$ret$0 = tmp;
    $reportTo.set_state_wnfcx0_k$(tmp$ret$0);
    return Unit_instance;
  }), 1);
}
function invoke(_this__u8e3s4, actionToCalculate) {
  return reactive(this, VOID, ($this$reactive) => {
    _this__u8e3s4.set(actionToCalculate($this$reactive));
    return Unit_instance;
  });
}
function bind(_this__u8e3s4, master) {
  var reportTo = RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$(_ReactiveState___init__impl__fvdp9b(Unit_instance));
  var tmp0_safe_receiver = this.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.watchBackgroundProcess_1utgjt_k$(reportTo);
  launch(this, VOID, VOID, CoroutineScopeHelpers$bind$slambda(reportTo, master, _this__u8e3s4, this));
}
function debounce(_this__u8e3s4, timeMs) {
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance_0();
  var tmp$ret$0 = toDuration(timeMs, DurationUnit_MILLISECONDS_getInstance());
  return new (DebounceReactive())(_this__u8e3s4, this, tmp$ret$0);
}
function debounce_0(_this__u8e3s4, duration) {
  return new (DebounceReactive())(_this__u8e3s4, this, duration);
}
var CoroutineScopeHelpersClass;
function CoroutineScopeHelpers() {
  if (CoroutineScopeHelpersClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'CoroutineScopeHelpers');
    CoroutineScopeHelpersClass = $;
  }
  return CoroutineScopeHelpersClass;
}
function oneAtATime(_this__u8e3s4, work, action) {
  var lastJob = {_v: null};
  var reportTo = RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$(_ReactiveState___init__impl__fvdp9b(Unit_instance));
  if (work) {
    var tmp0_safe_receiver = _this__u8e3s4.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.watchForegroundProcess_2u2sac_k$(reportTo);
  } else {
    var tmp1_safe_receiver = _this__u8e3s4.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance);
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.watchBackgroundProcess_1utgjt_k$(reportTo);
  }
  return (it) => {
    var tmp0_safe_receiver = lastJob._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel$default_8haxne_k$();
    }
    // Inline function 'kotlin.let' call
    var tmp0 = _this__u8e3s4;
    var tmp$ret$1;
    $l$block_0: {
      var done = {_v: false};
      var tmp;
      var tmp0_safe_receiver_0 = tmp0.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_getInstance());
      if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.isDispatchNeeded_ft82v4_k$(tmp0.get_coroutineContext_115oqo_k$())) === false) {
        tmp = CoroutineStart_UNDISPATCHED_getInstance();
      } else {
        tmp = CoroutineStart_DEFAULT_getInstance();
      }
      var tmp_0 = tmp;
      var job = launch(tmp0, VOID, tmp_0, oneAtATime$lambda$slambda(action, it, done, reportTo));
      if (done._v) {
        tmp$ret$1 = null;
        break $l$block_0;
      } else {
        reportTo.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
        tmp$ret$1 = job;
        break $l$block_0;
      }
    }
    var tmp$ret$0 = tmp$ret$1;
    lastJob._v = tmp$ret$0;
    return Unit_instance;
  };
}
function oneAtATime$lambda$slambda($action, $it, $done, $reportTo) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.core.reactiveState' call
    var tmp;
    try {
      yield* $($action($it, $completion), $completion);
      tmp = _ReactiveState___init__impl__fvdp9b(Unit_instance);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException()) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof ReactiveLoading()) {
          var _unused_var__etf5q3 = $p;
          tmp_0 = Companion_getInstance().notReady_1;
        } else {
          if ($p instanceof Exception()) {
            var e_0 = $p;
            tmp_0 = Companion_getInstance().exception_iibuh2_k$(e_0);
          } else {
            throw $p;
          }
        }
      }
      tmp = tmp_0;
    }
    var result = tmp;
    $done._v = true;
    $reportTo.set_state_wnfcx0_k$(result);
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  bind as bind1v20po654iwh5,
  debounce_0 as debounce2ek3q4aktnyhg,
  debounce as debounce3va8k9t2b2qkc,
  invoke as invoke3ik0mg5nfxrhr,
  CoroutineScopeHelpers as CoroutineScopeHelpers1j3li0lv9e54a,
};
//endregion

//# sourceMappingURL=CoroutineScopeHelpers.mjs.map
